export const ITEM_SIZE = 44;
export const MAX_VISIBLE_ROWS = 10;
